import instance from "api";
import {IDynamicTableParams} from "components/DynamicTable";
import {IRepairTypeItem} from "pages/PageRepairTypes/interfaces";
import {IDictionaryItem} from "components/SimpleDictionary/interfaces";

export const getRepairTypes = (data: IDynamicTableParams) => {
    return instance().post<IRepairTypeItem[]>("/dictionary/repairType/list", data).then(response => response.data);
}

export const getAvailableColumns = () => {
    return instance().post("/dictionary/repairType/availableColumns").then(response => response.data);
}

export const getAvailableGroupColumns = () => {
    return instance().post("/dictionary/repairType/availableGroupColumns").then(response => response.data);
}

export const addNewRepairType = (data: IDictionaryItem) => {
    return instance().post("/dictionary/repairType/save",
        {repairTypeName: data.name}).then(response => response.data);
}

export const updateRepairType= (data: IDictionaryItem) => {
    return instance().post("/dictionary/repairType/update",
        {repairTypeId: data.id, repairTypeName: data.name}).then(response => response.data);
}

export const deleteRepairType = (repairTypeId: number) => {
    return instance().post("/dictionary/repairType/delete",
        {repairTypeId}).then(response => response.data);
}

export const recoverRepairType = (repairTypeId: number) => {
    return instance().post("/dictionary/repairType/recover",
        {repairTypeId}).then(response => response.data);
}

export const getRepairType= (repairTypeId: number) => {
    return instance().post("/dictionary/repairType/get",
        {repairTypeId})
        .then(response => response.data);
}
